import { OebbI18n, findLocale as findLocaleFromLibrary } from "@oebb-web-team/oebb-web-library/dist/i18n/OebbI18n";
import { generalI18n } from "../global/general-i18n";
export function findLocale(element) {
    return findLocaleFromLibrary(element);
}
export function getLocalizedString(str) {
    var _a;
    if (!str) {
        return null;
    }
    const lang = i18n.getLang();
    return (_a = str[lang]) !== null && _a !== void 0 ? _a : str.int;
}
const i18n = new OebbI18n();
i18n.add(generalI18n);
export { i18n };
//# sourceMappingURL=I18n.js.map
